export const BILLING_FAQ_ARTICLE_LINK =
  "https://support.clipboardhealth.com/hc/en-us/articles/9310343544983-Facility-billing-FAQs";

export const PENDING_SETTINGS_HELP_LINK =
  "https://clipboardhealth.atlassian.net/wiki/spaces/AR/pages/3758227489/SOP+Automated+Pending+Notice+Email";
